import { DefaultTheme } from 'styled-components';
import breakpoints from '../breakpoints';

const device: DefaultTheme['device'] = {
  mobileS: `(min-width: ${breakpoints.mobileS}px)`,
  mobileM: `(min-width: ${breakpoints.mobileM}px)`,
  mobileL: `(min-width: ${breakpoints.mobileL}px)`,
  tablet: `(min-width: ${breakpoints.tablet}px)`,
  laptopS: `(min-width: ${breakpoints.laptopS}px)`,
  laptopM: `(min-width: ${breakpoints.laptopM}px)`,
  laptop: `(min-width: ${breakpoints.laptop}px)`,
  laptopL: `(min-width: ${breakpoints.laptopL}px)`,
  laptopLM: `(min-width: ${breakpoints.laptopLM}px)`,
  laptopXL: `(min-width: ${breakpoints.laptopXL}px)`,
  desktop: `(min-width: ${breakpoints.desktop}px)`,
  desktopL: `(min-width: ${breakpoints.desktopL}px)`,
  iphoneX: `only screen and (device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3)`,
  retinaDesktop: `
    only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: ${breakpoints.tablet}px),
    only screen and (min--moz-device-pixel-ratio: 2) and (min-width: ${breakpoints.tablet}px),
    only screen and (-o-min-device-pixel-ratio: 2/1) and (min-width: ${breakpoints.tablet}px),
    only screen and (min-device-pixel-ratio: 2) and (min-width: ${breakpoints.tablet}px),
    only screen and (min-resolution: 192dpi) and (min-width: ${breakpoints.tablet}px),
    only screen and (min-resolution: 2dppx) and (min-width: ${breakpoints.tablet}px)`,
  retina: `
    only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (min--moz-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 192dpi),
    only screen and (min-resolution: 2dppx)`,
};

export default device;
